module.exports = __webpack_public_path__ + "static/IoT-672c9441654d65e417673f0c4c3386ef.jpg";